<div class="card kpi-grey change-city">
    <div class="card-body kpi-card">
        <h5 class="card-title">Sélection de la ville</h5>
        <div>
            <ng-container *ngIf="preview">- %</ng-container>
            <ng-container *ngIf="!preview">
                <mat-form-field class="no-label">
                    <mat-label>Ville et/ou code postal</mat-label>
                    <input type="text"
                           class="text"
                           matInput
                           [(ngModel)]="favorite.ad_city.name"
                           [formControl]="cityControl"
                           [matAutocomplete]="auto">
                    <mat-autocomplete (optionSelected)='changeCity($event.option.value)' autoActiveFirstOption #auto="matAutocomplete">
                        <mat-option *ngFor="let city of cities" [value]="city">
                            {{city.name}}
                            ({{ city.display_zip_code == '' ? city.zip_code : city.display_zip_code.includes(',') ? 'Toute la ville' : city.display_zip_code }})
                        </mat-option>
                    </mat-autocomplete>
                    <span matSuffix><div class="citySpinner" style="display: none;"><mat-spinner diameter="20"></mat-spinner></div></span>
                </mat-form-field>
            </ng-container>
        </div>
    </div>
</div>
